export const RoutesPaths = {
  LOGIN: "/",
  DASHBOARD: "/dashboard",
  CATEGORIES:'/category',
  ADDCATEGORIES:'/category/add-category',
  EDITCATEGORIES:'/category/edit-category/:id',
  STORS:"/stors",
  ADDSTORS:"/stors/add-store",
  EDITSTORS:"/stors/edit-store/:id",
  VIEWSTORS:"/stors/:id",
  USERS:"/users",
  CHATS:"/chats",
  PROFILE:"/profile",
  BANNER:'/banner',
  ADDBANNER:'/banner/add-banner',
  EDITBANNER:'/banner/edit-banner/:id',
  PROMOTIONALBANNER:'/promotional-banner',
  ADDPROMOTIONALBANNER:'/promotional-banner/add-banner',
  EDITPROMOTIONALBANNER:'/promotional-banner/edit-banner/:id',
};

// export const backendUrl = "http://192.168.1.14:5000/";
// export const backendImageUrl = "http://192.168.1.14:5000/";

export const googleApiKey = process.env.REACT_APP_GOOGLE_API
export const backendUrl = process.env.REACT_APP_API_URL
export const backendImageUrl = process.env.REACT_APP_API_URL;